export const TIMERS_IDS = {
    ALL_EVENTS: 'ALL_EVENTS',
    ALL_ATTRIBUTES: 'ALL_ATTRIBUTES',
    ALL_CHANGE_REQUESTS: 'ALL_CHANGE_REQUESTS',
};

const INTERVAL_UPDATE_DATA_MINUTES = 30;
export const INTERVAL_UPDATE_DATA_SECONDS = INTERVAL_UPDATE_DATA_MINUTES * 60;
